import Vue from 'vue'
import App from './App.vue'
import router from './router';
Vue.config.productionTip = false
import './utils/rem.js'
new Vue({
    router, // 使用 router
    render: h => h(App),
}).$mount('#app')